import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../api';
import { useT } from '../i18n';
import Wordmark from '../components/Wordmark';
import Notice from '../components/Notice';

export default function ForgotPassword() {
  const { t } = useT();
  const [identifier, setIdentifier] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await forgotPassword(identifier); setSent(true); }
    catch (err) { setError((err as Error).message); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-dvh flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="card w-full max-w-sm p-6 space-y-5">
        <Wordmark />
        <div><h1 className="text-xl font-semibold">{t('f.title')}</h1><p className="text-dim text-sm mt-1">{t('f.blurb')}</p></div>
        {sent ? <Notice kind="success">{t('f.sent')}</Notice> : (
          <>
            <div>
              <label className="label" htmlFor="identifier">{t('login.identifier')}</label>
              <input id="identifier" autoComplete="username" autoCapitalize="none" autoCorrect="off" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required />
            </div>
            {error && <Notice kind="error">{error}</Notice>}
            <button className="btn-primary w-full" disabled={busy}>{busy ? t('f.busy') : t('f.submit')}</button>
          </>
        )}
        <p className="text-xs text-dim">{t('f.noemail')}</p>
        <Link to="/" className="block text-center text-sm text-dim hover:text-chalk">{t('f.back')}</Link>
      </form>
    </div>
  );
}
